"use strict";var e=!("undefined"==typeof window||!window.document||!window.document.createElement);exports.canUseDOM=e;
//# sourceMappingURL=utils.js.map
